import {API2_CHATS, API2_TENANTS} from 'consts/api2'
import BaseStore from './base-store'

export default class extends BaseStore {
  constructor(tenant_id) {
    super({
      feed_filter_prompt: undefined,
      af_topics: undefined,
      af_companies: undefined,
      pulse_context: undefined,
      chat_context: undefined,
      feed_digest_days: undefined,
      preferred_sources: undefined,
      skills: undefined,
      sources: undefined,
      apollo_tool_enabled: false,
      persona_news_enabled: true,
      artifacts_enabled: false,
      timezone: undefined,
    })
    this.tenant_id = tenant_id
    this.api_path = `${API2_TENANTS}/${this.tenant_id}/settings`
    this.caps = {skills: [], sources: []}
  }

  async doLoad(_, {load_caps = false}) {
    const requests = [this.getAll()]
    if (load_caps) {
      requests.push(this._rest.get(`${API2_CHATS}/caps/all`, {tenant_id: this.tenant_id}))
    }
    const [settings, caps] = await Promise.all(requests)

    if (load_caps) {
      this.caps = caps
      this._state.skills = caps.default_skills || []
      this._state.sources = caps.default_sources || []
    }
    settings.forEach(({key, value}) => this._state[key] = value)
  }

  async doSave(_, changed) {
    const to_write = []
    for (const key of changed) to_write.push({key, value: this._state[key]})
    await this._rest.put(this.api_path, {settings: to_write})
  }

  async getAll() {
    return await this._rest.get(this.api_path)
  }
}
